import { useTranslation } from "../../hooks/useTranslation";
import { ButtonContainer, ButtonContainerInside, StyledTypography, useClasses } from "./CloseButton.style";

export const CloseButton: React.FC<{
  isToExpand: string | boolean;
  config: any;
  handleClose: any;
 
  closeButtonLabel?: string;
}> = ({ isToExpand, config, handleClose,  closeButtonLabel }) => {
  const { t } = useTranslation();
  const classes = useClasses();

 return (
    <ButtonContainer 
      buttonPosition = {config.buttonPosition}
      buttonLocation = {config.buttonLocation}
      isToExpand= {isToExpand}
    
    >
      <ButtonContainerInside>
        {config.showHideForGoodButton !== undefined &&
        config.showHideForGoodButton ? (
          <StyledTypography
            variant="body1"
            onClick={(event: any) => handleClose(true)}
          >
            <div style={{ textAlign: "center" }}>
              {t("common.onScreenHelp.hideAllForGood")}
            </div>
          </StyledTypography>
        ) : (
          <div></div>
        )}
        <StyledTypography
          variant="body1"
          onClick={(event: any) => handleClose(false)}
          sx = {classes.ButtonContainerInside}
        >
          <div style={{ textAlign: "center" }}>
            {t(closeButtonLabel ? closeButtonLabel : "common.close")}
          </div>
        </StyledTypography>
      </ButtonContainerInside>
    </ButtonContainer>
  );
}
